import React from "react";

interface RegionsRiskTopbarProps {
  onSidebarToggle: () => void;
}

export const RegionsRiskTopbar: React.FC<RegionsRiskTopbarProps> = ({
  onSidebarToggle,
}) => {
  return (
    <header className="flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3.5">
        <button
          onClick={onSidebarToggle}
          className="lg:hidden w-8 h-8 rounded-full border border-[rgba(139,146,176,0.5)] bg-[rgba(5,7,22,0.8)] flex items-center justify-center cursor-pointer text-lg"
          aria-label="Toggle navigation"
        >
          ☰
        </button>
        <div className="flex flex-col gap-0.5">
          <h1 className="text-xl font-semibold tracking-[0.04em] flex items-center gap-2">
            Regions & Risk
            <span className="text-[13px] px-2 py-0.75 rounded-full border border-[rgba(0,212,255,0.4)] text-cyber-blue uppercase tracking-[0.12em]">
              Geographic risk intelligence
            </span>
          </h1>
          <p className="text-[13px] text-[#8b92b0]">
            See where risk is building across Canada – by metro, province and
            product mix.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 flex-wrap justify-end">
        <div className="inline-flex items-center gap-2 px-3 py-1.75 rounded-full border border-[rgba(139,146,176,0.5)] bg-[rgba(10,14,39,0.9)] text-xs text-[#8b92b0] cursor-pointer">
          <span>Metric: Default rate</span>
          <span>▾</span>
        </div>
        <div className="inline-flex items-center gap-2 px-3 py-1.75 rounded-full border border-[rgba(139,146,176,0.5)] bg-[rgba(10,14,39,0.9)] text-xs text-[#8b92b0] cursor-pointer">
          <span>Window: Last 12 months</span>
          <span>▾</span>
        </div>
        <button className="px-4 py-2 rounded-full border-none cursor-pointer text-[13px] font-semibold font-inherit bg-gradient-to-r from-cyber-blue to-blockchain-purple text-white shadow-[0_10px_30px_rgba(0,212,255,0.4)] inline-flex items-center gap-2 whitespace-nowrap transition-all duration-100 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(0,212,255,0.6)] active:translate-y-0 active:shadow-[0_6px_20px_rgba(0,212,255,0.4)]">
          Export region snapshot
          <span className="text-sm">⇩</span>
        </button>
        <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-full bg-[rgba(10,14,39,0.9)] border border-[rgba(139,146,176,0.4)] text-xs cursor-pointer">
          <div className="w-6.5 h-6.5 rounded-full bg-gradient-to-br from-cyber-blue via-blockchain-purple via-neon-green to-cyber-blue relative overflow-hidden">
            <div className="absolute inset-1 rounded-full bg-gradient-to-br from-white/50 to-transparent mix-blend-screen" />
          </div>
          <span>Patrick</span>
        </div>
      </div>
    </header>
  );
};
